import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

type AddMaterialsArgs = {
    folderIds: number[];
    materialIds: number[];
};

export const addMultipleMaterials = ({ folderIds, materialIds }: AddMaterialsArgs) => {
    const queryFilter = `{in: {id: [${materialIds.toString()}] }}`;

    return axios.post(`${API_URLS.FOLDERS.MATERIALS}/add-by-query`, {
        folder_ids: folderIds,
        queryFilter
    });
};
